module.exports = __webpack_public_path__ + "static/media/swab.f158dcdd.svg";